import { IconButton, Tooltip } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import PortalModal from "../../Portals";
import ErrorOutlinedIcon from "@material-ui/icons/ErrorOutlined";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  ContentModal,
  ButtonConfirm,
  ButtonCancel,
  CloseModal,
  TextModal,
} from "./ModalActivateAction.styled";

const ModalActivateAction = ({
  title,
  open,
  setOpen,
  fn,
  setNewOwner,
  newOwner,
}) => {
  const [otherOwnerChecked] = useState(false);

  useEffect(() => {
    cleanSelection();
  }, [otherOwnerChecked]);

  let cleanSelection = () => {
    if (otherOwnerChecked) {
      setNewOwner();
    }
  };

  /*   let handleOtherOwner = (e) => {
    setOtherOwnerChecked(e.target.checked);
  };
  let handleChangeSelectOwner = (item) => {
    setNewOwner(item.ccmsuser);
  }; */

  return (
    <PortalModal>
      <ContentModal>
        <CloseModal>
          <Tooltip title="close">
            <IconButton onClick={() => setOpen(null)}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </CloseModal>
        <TextModal>
          <div style={{ textAlign: "center" }}>
            <ErrorOutlinedIcon />
            <p>{title}</p>
          </div>
        </TextModal>
        <div style={{ display: "inline-flex", margin: "auto", width: "100%" }}>
          <ButtonConfirm
            isDisabled={otherOwnerChecked && !newOwner}
            onClick={() => {
              if (otherOwnerChecked && !newOwner) {
                //do nothing
              } else {
                fn(open);
              }
            }}
          >
            {"Yes"}
          </ButtonConfirm>
          <ButtonCancel onClick={() => setOpen(null)}>{"No"}</ButtonCancel>
        </div>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalActivateAction;
